export const initTheme = function initTheme(theme) {
  document.body.setAttribute('data-theme', theme);
};

export const getSystemPrefersDarkMode = function getSystemPrefersDarkMode() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
};
